import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@material-ui/core';

const ConfirmDeleteSubcategoryModal = ({
  onConfirmClick,
  onCancelClick,
  open,
}) => (
  <Dialog
    open={open}
    onClose={onCancelClick}
  >
    <DialogTitle>Are you sure?</DialogTitle>
    <DialogContent>
      <DialogContentText>Are you sure you want to delete this sub-category?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancelClick} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirmClick} color="primary" variant="contained">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmDeleteSubcategoryModal.propTypes = {
  onConfirmClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  open: PropTypes.bool,
};

ConfirmDeleteSubcategoryModal.defaultProps = {
  onConfirmClick: () => {},
  onCancelClick: () => {},
  open: false,
};

export default ConfirmDeleteSubcategoryModal;
